const getAllUnits = async (params = {}) => {
    let data = [];
    let pagination = { offset: '', total: 0 };

    do {
        const response = (await ApiClient.get('/units', { ...params, offset: pagination.offset }))
            .data;
        pagination = response?.pagination ?? pagination;
        data = data.concat(response?.data ?? []);
    } while (data.length < pagination.total);
    return data;
};

const getUnitSettings = () => {
    return ApiClient.get('/settings/units');
};

const getUnitCodeSuggestions = (units = []) => {
    return ApiClient.post('/units/codes-suggestions', {}, units);
};

const saveUnits = (units = []) => {
    return ApiClient.post('/units/batch', {}, units);
};

const saveUnitSettings = (settings = {}, signal = undefined) => {
    return ApiClient.put('/settings/units', {}, settings, signal);
};

export { getAllUnits, getUnitCodeSuggestions, saveUnits, saveUnitSettings, getUnitSettings };
